import {
  InstagramLogo,
  TiktokLogo,
  YoutubeLogo,
  XLogo,
} from "@phosphor-icons/react";

export const PlatformIcon = ({ platform, size = 20 }) => {
  const icons = {
    instagram: <InstagramLogo size={size} weight="fill" className="text-[#E1306C]" />,
    tiktok: <TiktokLogo size={size} weight="fill" className="text-black" />,
    youtube: <YoutubeLogo size={size} weight="fill" className="text-[#FF0000]" />,
    twitter: <XLogo size={size} weight="fill" className="text-[#0F1419]" />,
  };
  return icons[platform] || null;
};
